export default "<!-- Divider -->\n<div class=\"treo-vertical-navigation-item-wrapper divider\"></div>\n"